<template>
  <div>
    <RevCard
      v-if="!isFetchingPending"
      class="mb-16 flex flex-col justify-between p-20"
    >
      <div class="m-auto flex w-[fit-content] justify-center">
        <ChartCircle
          class="m-auto h-[12rem] w-[12rem] p-16"
          :value="tasksCompletionRate"
        >
          <div class="text-[2rem]" variant="body-1">
            {{ tasksCompletionRate }}%
          </div>
        </ChartCircle>
      </div>
      <div class="body-1-bold">{{ i18n(statsBlockContent.title) }}</div>
      <div class="body-1">{{ i18n(statsBlockContent.description) }}</div>
      <RevIllustration
        :alt="i18n(statsBlockContent.title)"
        class="m-auto mt-8"
        :height="61"
        src="/img/onboarding/laying-phone.svg"
        :width="153"
      />
    </RevCard>
    <RevCard
      v-if="isFetchingPending"
      class="mb-16 flex flex-col justify-between p-10"
    >
      <RevSkeleton
        class="m-auto mb-16"
        height="18rem"
        shape="circle"
        width="18rem"
      />
      <RevSkeleton class="mb-8" height="12px" shape="line" width="100%" />
      <RevSkeleton class="mb-8" height="12px" shape="line" width="100%" />
      <RevSkeleton class="mb-8" height="12px" shape="line" width="80%" />
      <RevIllustration
        :alt="i18n(statsBlockContent.title)"
        class="m-auto mt-8"
        :height="61"
        src="/img/onboarding/laying-phone.svg"
        :width="153"
      />
    </RevCard>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { RevIllustration } from '@ds/components/Illustration'
import { RevSkeleton } from '@ds/components/Skeleton'

import { getStatsBlockContent } from './OnboardingChart.utils'

const i18n = useI18n()

const props = defineProps<{
  requiredTaskAmount: number
  onGoingRequiredTasksAmount: number
  isFetchingPending: boolean
}>()

const tasksCompletionRate = computed(() => {
  const rate =
    ((props.requiredTaskAmount - props.onGoingRequiredTasksAmount) /
      props.requiredTaskAmount) *
    100

  // since ChartCircle expect a Number and toFixed return a string, we need to convert it to a number again
  return Number(rate.toFixed(0))
})

const statsBlockContent = computed(() =>
  getStatsBlockContent(tasksCompletionRate.value),
)
</script>
